import { createStore } from '@souche-f2e/muji';

const state = {
  itemPath: '所有FAQ',
  docId: '',
  docType: '',
}

export default createStore({
  state,
  reducers: {
    UPDATE_ROUTE(state, payload) {
      return {
        ...state,
        ...payload
      }
    },
  },
  effects: {
    updatePath(payload, { state, rootState }) {
      this.UPDATE_ROUTE(payload)
    }
  },
  async setup({ history }) {
    history.listen(route => {
      if (route.path === '/support/FAQ')  {
        const { docId, docType } = route.query;
        this.updatePath({
          docId: docId !== undefined ? docId : '',
          docType: docType !== undefined ? docType : '',
        });
      }
    })
  },
});